<template>
  <div class="ec-start">
    <div class="ec-top">
      <button class="close" @click="close">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.559099 0.559099C0.917199 0.201108 1.40282 0 1.90917 0C2.41553 0 2.90115 0.201108 3.25925 0.559099L10.0115 7.31138L16.7638 0.559099C17.124 0.211254 17.6063 0.0187787 18.107 0.0231296C18.6077 0.0274804 19.0866 0.228309 19.4407 0.582361C19.7947 0.936413 19.9956 1.41536 19.9999 1.91605C20.0043 2.41673 19.8118 2.8991 19.464 3.25925L12.7117 10.0115L19.464 16.7638C19.8118 17.124 20.0043 17.6063 19.9999 18.107C19.9956 18.6077 19.7947 19.0866 19.4407 19.4407C19.0866 19.7947 18.6077 19.9956 18.107 19.9999C17.6063 20.0043 17.124 19.8118 16.7638 19.464L10.0115 12.7117L3.25925 19.464C2.8991 19.8118 2.41673 20.0043 1.91605 19.9999C1.41536 19.9956 0.936413 19.7947 0.582361 19.4407C0.228309 19.0866 0.0274804 18.6077 0.0231296 18.107C0.0187787 17.6063 0.211254 17.124 0.559099 16.7638L7.31138 10.0115L0.559099 3.25925C0.201108 2.90115 0 2.41553 0 1.90917C0 1.40282 0.201108 0.917199 0.559099 0.559099Z" fill="white"/></svg>
      </button>
    </div>
    <div class="ec-row">
      <div class="text">
        <h2>Are you eligibile to study?</h2>
        <p>Find out whether you're eligible to study a degree with us</p>
        <button class="btn-red-wide desktop-button" @click="begin">
          <span>Begin</span>
          <svg width="13" height="23" viewBox="0 0 13 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.698418 0.984253C0.385238 1.29441 0.209302 1.71503 0.209302 2.1536C0.209302 2.59216 0.385238 3.01278 0.698418 3.32294L8.96765 11.51L0.698417 19.697C0.394112 20.009 0.22573 20.4268 0.229536 20.8604C0.233342 21.2941 0.409032 21.7089 0.718766 22.0156C1.0285 22.3222 1.4475 22.4962 1.88551 22.4999C2.32352 22.5037 2.74551 22.337 3.06058 22.0357L12.5109 12.6793C12.8241 12.3692 13 11.9486 13 11.51C13 11.0714 12.8241 10.6508 12.5109 10.3406L3.06058 0.984253C2.7473 0.674186 2.32247 0.5 1.8795 0.5C1.43653 0.499999 1.01169 0.674186 0.698418 0.984253Z" fill="white"/></svg>
        </button>
      </div>
      <div class="images">
        <div class="image">
          <img src="./../assets/images/start.png">
          <div class="ec-dots"><img src="./../assets/images/dots-grid.svg"></div>
        </div>
      </div>
    </div>
    <div class="cta">
      <button class="btn-red-wide" @click="begin">
        <span>Begin</span>
        <svg width="13" height="23" viewBox="0 0 13 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.698418 0.984253C0.385238 1.29441 0.209302 1.71503 0.209302 2.1536C0.209302 2.59216 0.385238 3.01278 0.698418 3.32294L8.96765 11.51L0.698417 19.697C0.394112 20.009 0.22573 20.4268 0.229536 20.8604C0.233342 21.2941 0.409032 21.7089 0.718766 22.0156C1.0285 22.3222 1.4475 22.4962 1.88551 22.4999C2.32352 22.5037 2.74551 22.337 3.06058 22.0357L12.5109 12.6793C12.8241 12.3692 13 11.9486 13 11.51C13 11.0714 12.8241 10.6508 12.5109 10.3406L3.06058 0.984253C2.7473 0.674186 2.32247 0.5 1.8795 0.5C1.43653 0.499999 1.01169 0.674186 0.698418 0.984253Z" fill="white"/></svg>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      // NOTE for testing
      // <p>{{ nodeEnv }} - {{ publicPath }}</p>
      // publicPath: process.env.BASE_URL,
      // nodeEnv: process.env.NODE_ENV
    }
  },
  computed: mapState({
    isModal: state => state.isModal
  }),
  methods: {
    begin () {
      this.$router.push('/step/1')
    },
    close () {
      this.$store.commit('hideModal')
      this.$router.push('/')
    }
    // NOTE for testing
    // <img :src="getImgSrc('dot-grid.svg')" class="dots">
    // <img :src="getImgSrc('start.png')" class="image">
    // getImgSrc (img) {
    //   return process.env.NODE_ENV === 'development' ? '/app/themes/swinburne/eligibility/src/assets/images/' + img : './../assets/images/' + img
    // }
  }
}
</script>
<style lang="scss">
@import "./../assets/scss/variables";
@import "./../assets/scss/mixins";

.ec-start {
  display: block;
  background-color: $sol_black;
  color: #fff;
  padding: 1rem 1.5rem;
  height: 100%;

  .ec-top {
    display: flex;
    justify-content: flex-end;
    margin-right: -1rem;

    @include respond-above(md) {
      margin-bottom: 3.5rem;
      margin-right: -3.5rem;
    }
  }

  .close {
    &::before {
      background: transparent;
    }
  }

  .ec-row {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 1.25rem;

    @include respond-above(md) {
      flex-direction: row;
      margin-bottom: 0;
    }
  }

  .text,
  .images {
    padding: 1rem;
    position: relative;
  }

  .text {
    flex-grow: 1;

    button {
      display: none;
    }
  }

  .desktop-button {
    display: none !important;
  }

  .cta {
    width: 100%;
    position: relative;

    button {
      width: 100%;
    }
  }

  @include respond-above(md) {
    padding: 1.5rem 4.5rem 4.5rem;

    .text {
      width: 45%;
      flex-grow: 0;
      padding: 2rem;

      button {
        display: flex !important;
      }
    }

    .images {
      width: 55%;
      flex-grow: 0;
      position: relative;
    }

    .cta {
      display: none;
    }
  }

  .image {
    position: relative;
    z-index: 1;
    margin: 0 2.5rem 2rem 0;

    .ec-dots {
      position: absolute;
      right: -40px;
      bottom: -40px;
      z-index: -1;
    }

    @include respond-above(md) {
      margin: 0 2.5rem 3.5rem 0;

      .ec-dots {
        position: absolute;
        right: -60px;
        bottom: -70px;
        z-index: -1;
      }
    }

    img {
      width: 100%;
      height: auto;
    }
  }

  .dots {
    position: absolute;
    z-index: 0;
    bottom: 0;
    right: -0.75rem;
    width: 90%;

    @include respond-above(md) {
      bottom: -3rem;
    }
  }

  h2 {
    font-style: normal;
    font-family: $font-family-din;
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 1px;
    color: #fff;
    margin: 0 0 1.75rem;

    @include respond-above(md) {
      font-size: 48px;
      line-height: 56px;
      margin: 0 0 3rem;
    }
  }

  p {
    font-style: normal;
    font-family: $font-family-sans;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 0.5px;
    color: $offWhite;
    margin: 0;

    @include respond-above(md) {
      margin: 0 0 4rem;
    }
  }
}
</style>
